module.exports = __webpack_public_path__ + "media/images/signin-image-1919f50d9d26d4c1d1a07921b0a7b7d2.jpg";